import { createStore } from 'vuex'
import products from '@/mock/products'
import categories from '@/mock/categories'
import company from '@/mock/company'

export default createStore({
  state: {
    // 产品列表
    products: products,
    // 产品分类
    categories: categories,
    // 公司信息
    company: company,
    // 搜索关键词
    searchKeyword: '',
    // 当前选中的分类
    selectedCategory: null
  },
  getters: {
    // 获取所有产品
    allProducts: state => state.products,
    // 获取所有分类
    allCategories: state => state.categories,
    // 获取公司信息
    companyInfo: state => state.company,
    // 根据分类获取产品
    productsByCategory: state => (categoryId) => {
      return state.products.filter(p => p.categoryId === categoryId)
    },
    // 根据ID获取产品
    productById: state => (id) => {
      return state.products.find(p => p.id === id)
    }
  },
  mutations: {
    SET_SEARCH_KEYWORD (state, keyword) {
      state.searchKeyword = keyword
    },
    SET_SELECTED_CATEGORY (state, categoryId) {
      state.selectedCategory = categoryId
    }
  },
  actions: {
    // 预留后端API调用
    // async fetchProducts ({ commit }) {
    //   const response = await api.get('/products')
    //   commit('SET_PRODUCTS', response.data)
    // },
    setSearchKeyword ({ commit }, keyword) {
      commit('SET_SEARCH_KEYWORD', keyword)
    },
    setSelectedCategory ({ commit }, categoryId) {
      commit('SET_SELECTED_CATEGORY', categoryId)
    }
  },
  modules: {
    user: require('./modules/user').default
  }
})
